// src/components/PP1ExamsDownload.js
import React from 'react';
import {SchemesDownload} from '../hooks/SchemesOperations';

const Grade1ExaminationsDownload = ({ isAdmin, isLoggedIn, clearToken ,isSubscribed}) => {
    return (
    
       
        <SchemesDownload
            isAdmin={isAdmin}
            isSubscribed={isSubscribed}
            isLoggedIn={isLoggedIn}
            clearToken={clearToken}
            heading="GRADE 1 EXAMINATIONS"
        />
        
    );
};

export default Grade1ExaminationsDownload ;
